import * as Styled from '../../../components/HomePage/styles/HomePage.styled';
import { SectionsProps } from '../../../features/landing/Sections/Sections.typed';
import { useVerticalContext } from '../../../contexts/VerticalContext';
import { VERTICAL } from '../../../helpers/verticals';
import { FarmingSectionsList } from '../../../components/HomePage/components/SectionBrowser/FarmingSectionsList';
import { MotorSectionsList } from '../../../components/HomePage/components/SectionBrowser/MotorSectionsList';
import { MarketplaceSectionsList } from '../../../components/HomePage/components/SectionBrowser/MarketPlaceSectionsList';
import { SkeletonBlock } from '../../../components/ToolkitV2/Skeleton/Skeleton';
import SectionContainer from '../../../components/HomePage/components/SectionBrowser/styles/SectionContainer';
import { SectionSlot } from '../../../components/Toolkit/SectionSlot/SectionSlot';

const Sections = (props: SectionsProps) => {
  const { title, sections, dashLinks, status } = props;
  const { vertical } = useVerticalContext();

  if (status === 'error') {
    return null;
  }

  if (status === 'pending') {
    return <SectionsSkeleton />;
  }

  return (
    <>
      <Styled.SectionHeader>
        <Styled.Heading as="h2">{title}</Styled.Heading>
      </Styled.SectionHeader>
      {vertical === VERTICAL.FARMING && (
        <FarmingSectionsList sections={sections} dashLinks={dashLinks} />
      )}

      {vertical === VERTICAL.MARKETPLACE && (
        <MarketplaceSectionsList sections={sections} dashLinks={dashLinks} />
      )}
      {vertical === VERTICAL.MOTOR && (
        <MotorSectionsList sections={sections} dashLinks={dashLinks} />
      )}
    </>
  );
};

const SectionsSkeleton = () => {
  return (
    <>
      <Styled.SectionHeader>
        <SkeletonBlock w="194px" h="16px" />
      </Styled.SectionHeader>
      <SectionContainer data-testid="skeleton-list">
        {Array.from({ length: 20 }, (_, index) => (
          <SectionSlot
            key={index}
            icon={<SkeletonBlock as="span" w="40px" h="40px" />}
            text={<SkeletonBlock as="span" w="194px" h="14px" />}
          />
        ))}
      </SectionContainer>
    </>
  );
};

export { Sections };
